import { create } from 'zustand'
import type { PlatformEvent } from '@/features/events/types'
import type { CustomerJourneyEvent } from '@/features/journey/types'

type EventLike = PlatformEvent | CustomerJourneyEvent

interface ModalState {
  /**
   * The currently selected event to display in the modal.
   * null means the modal is closed.
   */
  selectedEvent: EventLike | null

  /**
   * Open the event detail modal with the specified event
   */
  openEventDetail: (event: EventLike) => void

  /**
   * Close the event detail modal
   */
  closeEventDetail: () => void
}

export const useModalStore = create<ModalState>((set) => ({
  selectedEvent: null,

  openEventDetail: (event) => set({ selectedEvent: event }),

  closeEventDetail: () => set({ selectedEvent: null }),
}))
